var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104805",
    "data-name": "Group 104805",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226",
    "data-name": "Rectangle 146226",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#2ce47a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 139,
    height: 139,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Two",
    transform: "translate(70 116.508)",
    fill: "#2ce47a",
    fontSize: 11,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.162,
    y: 0
  }, "Custom")), /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate_black_24dp",
    transform: "translate(33.561 24.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    "data-name": "Path 61965",
    d: "M0,0H72.877V72.877H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79017",
    "data-name": "Group 79017",
    transform: "translate(4.476 2.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_153546",
    "data-name": "Rectangle 153546",
    transform: "translate(0 4)",
    fill: "none",
    stroke: "#29e67c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 60,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 59,
    rx: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104617",
    "data-name": "Group 104617"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    y1: 28,
    transform: "translate(31.5 18.5)",
    fill: "none",
    stroke: "#2ae57b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x2: 28,
    transform: "translate(17.5 32.5)",
    fill: "none",
    stroke: "#2ae57b",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/Custom.ea44e8525e4c20bfc844a096873cd33b.svg";
export { ForwardRef as ReactComponent };